import { motion } from 'framer-motion';
import { useState } from 'react';

const TestimonialSection = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const testimonials = [
    {
      quote:
        "I came in with one problem. I left with eleven. The bonus problems were completely unexpected and, honestly, more distressing than the original. Five stars.",
      author: 'Jennifer Martinez',
      role: 'Small Business Owner',
      image: 'https://i.pravatar.cc/150?img=47',
    },
    {
      quote:
        "Their team applied seventeen analytical frameworks to my squeaky door. I now understand it is not a door problem — it is a structural, existential, and interpersonal problem. I still haven't fixed it.",
      author: 'Robert Chen',
      role: 'Corporate Executive',
      image: 'https://i.pravatar.cc/150?img=33',
    },
    {
      quote:
        "I paid $15,000 for them to over-think my situation until it was completely unrecognizable. The three bonus problems they generated were complimentary. Truly a full-service experience.",
      author: 'Sarah Thompson',
      role: 'Entrepreneur',
      image: 'https://i.pravatar.cc/150?img=45',
    },
    {
      quote:
        "I was blissfully unaware of most of my problems before engaging their team. Now I have a 94-page report, a crisis escalation plan, and four new problems I didn't have on Monday. Remarkable.",
      author: 'Michael Rodriguez',
      role: 'Tech Founder',
      image: 'https://i.pravatar.cc/150?img=12',
    },
  ];

  return (
    <section className="relative py-32 bg-black overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage:
              'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
            backgroundSize: '40px 40px',
          }}
        ></div>
      </div>

      <div className="max-w-6xl mx-auto px-6 lg:px-12 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-20"
        >
          <span className="text-gold text-sm font-semibold tracking-widest uppercase mb-4 block">
            Client Testimonials
          </span>
          <h2 className="text-5xl md:text-6xl font-black text-white mb-6">
            What Our Clients Say
          </h2>
          <p className="text-xl text-light-gray max-w-2xl mx-auto">
            Real feedback from real people with newly identified real problems
          </p>
        </motion.div>

        <div className="relative">
          <motion.div
            key={activeIndex}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -30 }}
            transition={{ duration: 0.5 }}
            className="bg-dark-gray rounded-3xl p-12 md:p-16 border border-gold/20"
          >
            <div className="flex items-center justify-center mb-8">
              <div className="flex gap-2">
                {[...Array(5)].map((_, i) => (
                  <i
                    key={i}
                    className="ri-star-fill text-3xl text-gold"
                    aria-hidden="true"
                  ></i>
                ))}
              </div>
            </div>

            <blockquote className="text-2xl md:text-3xl text-white font-medium text-center mb-12 leading-relaxed">
              "{testimonials[activeIndex].quote}"
            </blockquote>

            <div className="flex items-center justify-center gap-4">
              <img
                src={testimonials[activeIndex].image}
                alt={testimonials[activeIndex].author}
                className="w-16 h-16 rounded-full object-cover"
              />
              <div className="text-left">
                <div className="text-xl font-bold text-white">
                  {testimonials[activeIndex].author}
                </div>
                <div className="text-light-gray">
                  {testimonials[activeIndex].role}
                </div>
              </div>
            </div>
          </motion.div>

          {/* Navigation Dots */}
          <div className="flex items-center justify-center gap-3 mt-12">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setActiveIndex(index)}
                className={`w-3 h-3 rounded-full transition-all duration-300 ${
                  index === activeIndex
                    ? 'bg-gold w-12'
                    : 'bg-light-gray/30 hover:bg-light-gray/50'
                }`}
                aria-label={`View testimonial ${index + 1}`}
              ></button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;